import type { DetectOptions, DetectionResult } from './types';

export const detectFromProcessTitleResult = (
  options: Pick<DetectOptions, 'processTitle'> = {}
): DetectionResult | null => {
  const processTitle = (options.processTitle ?? process.title)?.toLowerCase() ?? '';

  if (/^alacritty/.test(processTitle)) {
    return {
      terminal: 'alacritty',
      source: 'process_title'
    };
  }

  if (/^kitty/.test(processTitle)) {
    return {
      terminal: 'kitty',
      source: 'process_title'
    };
  }

  if (/^wezterm/.test(processTitle)) {
    return {
      terminal: 'wezterm',
      source: 'process_title'
    };
  }

  if (/^hyper/.test(processTitle)) {
    return {
      terminal: 'hyper',
      source: 'process_title'
    };
  }

  if (/^foot/.test(processTitle)) {
    return {
      terminal: 'foot',
      source: 'process_title'
    };
  }

  if (/^rio/.test(processTitle)) {
    return {
      terminal: 'rio',
      source: 'process_title'
    };
  }

  if (/^ghostty/.test(processTitle)) {
    return {
      terminal: 'ghostty',
      source: 'process_title'
    };
  }

  if (/bash/.test(processTitle)) {
    return {
      terminal: 'bash',
      source: 'process_title'
    };
  }

  if (/zsh/.test(processTitle)) {
    return {
      terminal: 'zsh',
      source: 'process_title'
    };
  }

  if (/ksh/.test(processTitle)) {
    return {
      terminal: 'ksh',
      source: 'process_title'
    };
  }

  if (/fish/.test(processTitle)) {
    return {
      terminal: 'fish',
      source: 'process_title'
    };
  }

  if (/csh/.test(processTitle)) {
    return {
      terminal: 'csh',
      source: 'process_title'
    };
  }

  if (/tcsh/.test(processTitle)) {
    return {
      terminal: 'tcsh',
      source: 'process_title'
    };
  }

  if (/pwsh/.test(processTitle)) {
    return {
      terminal: 'powershell',
      source: 'process_title'
    };
  }

  if (/powershell/.test(processTitle)) {
    return {
      terminal: 'powershell',
      source: 'process_title'
    };
  }

  if (/cmd/.test(processTitle)) {
    return {
      terminal: 'cmd',
      source: 'process_title'
    };
  }

  if (/sh$/.test(processTitle)) {
    return {
      terminal: 'sh',
      source: 'process_title'
    };
  }

  if (/^node/.test(processTitle)) {
    return {
      terminal: 'node',
      source: 'process_title'
    };
  }

  return null;
};

export const detectFromProcessTitle = (): string | null => {
  return detectFromProcessTitleResult()?.terminal ?? null;
};
